import { AccountResult } from 'src/types/accountResult';
import { ResetPasswordRequest } from 'src/types/resetPasswordRequest';
import { User } from 'src/types/user';
import { get, post, postWebApi } from './Api';

async function login(username: string, password: string): Promise<any> {
  return post<any>('/user/login', { username, password, applicationName: 'Vendor Portal' });
}

async function loginWebApi(username: string, password: string): Promise<any> {
  return postWebApi<any>('/login/login', { username, password, rememberMe: true });
}

async function logoutWebApi(): Promise<any> {
  return postWebApi<any>('/login/logout', {});
}

async function logout(): Promise<null> {
  return get<null>('/user/logout');
}

async function me(): Promise<User> {
  return get<User>('/user/me');
}

async function recoverPassword(email: string): Promise<AccountResult> {
  return post<AccountResult>('/user/recoverpassword?email=' + encodeURIComponent(email), {});
}

async function resetPassword(companyUserId: number, resetToken: string, newPassword: string): Promise<AccountResult> {
  let request: ResetPasswordRequest = {
    companyUserId: companyUserId,
    resetToken: resetToken,
    newPassword: newPassword,
  };

  return post<AccountResult>('/user/resetpassword', request);
}

export default {
  login,
  logout,
  me,
  recoverPassword,
  resetPassword,
  logoutWebApi,
  loginWebApi,
};
